import { Box } from '@mui/material'
import React from 'react'

export default function Loading() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '70vh' }}>
      <div className="loader"></div>
    </Box>
  )
}
